<template>
  <v-sheet class="text-start">
    <page-head title="Funds" :breadcrumb="['Membership', 'Funds']">
      <template v-slot>
        <v-btn variant="outlined" color="primary" :to="{ name: 'fundCreate' }"
          ><v-icon>mdi-plus</v-icon>Create Fund</v-btn
        >
        <v-btn variant="outlined" color="primary" @click="reportButtonClick">
          <v-icon>mdi-file-document-outline</v-icon>Issue Remain Fund Report
        </v-btn>
      </template>
    </page-head>
    <v-data-table-server
      :items="dataTable.items"
      :items-per-page="dataTable.itemsPerPage"
      :items-length="dataTable.totalItems"
      :headers="dataTable.headers"
      :loading="dataTable.isLoading"
      :items-per-page-options="dataTable.itemsPerPageOptions"
      @update:options="updateTopic"
    >
      <template v-slot:[`item.name`]="{ value, item }">
        <a :href="`/management/fund/id-${item.id}`">{{ value }}</a></template
      ></v-data-table-server
    >
  </v-sheet>
</template>

<script setup>
import PageHead from "@/components/admin_theme/PageHead.vue";
import { reactive } from "vue";
import { authAxios } from "@/util/Axios";
import { DEFAULT_DATATABLE } from "@/util/List";

const axios = authAxios();
const dataTable = reactive({
  headers: [{ title: "Name", key: "name", align: "start", sortable: false }],
  ...DEFAULT_DATATABLE,
});

function updateTopic({ page, itemsPerPage }) {
  dataTable.isLoading = true;
  loadTopic(page, itemsPerPage).then((response) => {
    dataTable.isLoading = false;
    dataTable.items = [...response.data.data];
    dataTable.totalItems = response.data.total_items;
  });
}

function loadTopic(page, length) {
  return axios({
    method: "GET",
    url: `${process.env.VUE_APP_BACKEND_URL}/api/member_fund/vuetify`,
    params: { page: page, length: length, search: "" },
  });
}

function reportButtonClick() {
  issueReport();
  alert("Report is issued and send to your email.");
}

function issueReport() {
  return axios({
    method: "POST",
    url: `${process.env.VUE_APP_BACKEND_URL}/api/member_fund/issue_remain_fund_report`,
  });
}
</script>
